import React from "react";
import withStyles from "components/with-styles";
import AppBar from "@material-ui/core/AppBar";
import styles from "./styles/page-header-wrapper.css.js";

const Wrapper = ({ classes, children }) => (
  <AppBar position="absolute" className={classes.page_header}>
    {children}
  </AppBar>
);

export default withStyles(styles)(Wrapper);
